var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pui-file-thumbnail-viewer',_vm._g(_vm._b({attrs:{"src":_vm.src,"fallbackText":_vm.extension}},'pui-file-thumbnail-viewer',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }